export default __webpack_public_path__ + "static/textAndImages_cloud_top-43a4848215cfd5176e5425390f870a32.png";